import React from 'react';
import { OptionHistoryMetricKey } from '../types/StockData';

interface OptionHistoryMetricSelectorProps {
  selectedMetric: OptionHistoryMetricKey;
  onMetricChange: (metric: OptionHistoryMetricKey) => void;
}

export const OptionHistoryMetricSelector: React.FC<OptionHistoryMetricSelectorProps> = ({
  selectedMetric,
  onMetricChange,
}) => {
  const metrics: { value: OptionHistoryMetricKey; label: string; description: string }[] = [
    { value: 'volume', label: 'Volume', description: 'Total trading volume' },
    { value: 'implied_volatility', label: 'Implied Volatility', description: 'IV percentage' },
    { value: 'bid_volume', label: 'Bid Volume', description: 'Volume on bid side' },
    { value: 'ask_volume', label: 'Ask Volume', description: 'Volume on ask side' },
    { value: 'mid_volume', label: 'Mid Volume', description: 'Volume at mid price' },
    { value: 'floor_volume', label: 'Floor Volume', description: 'Floor trading volume' },
    { value: 'sweep_volume', label: 'Sweep Volume', description: 'Sweep order volume' },
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h4 className="text-sm font-semibold text-gray-700 mb-4 uppercase tracking-wide">
        Select Metric
      </h4>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {metrics.map(({ value, label, description }) => (
          <button
            key={value}
            onClick={() => onMetricChange(value)}
            className={`p-3 rounded-lg text-left transition-all ${
              selectedMetric === value
                ? 'bg-blue-600 text-white shadow-md'
                : 'bg-gray-50 text-gray-700 hover:bg-gray-100 border border-gray-200'
            }`}
          >
            <div className="font-medium text-sm">{label}</div>
            <div className={`text-xs mt-1 ${
              selectedMetric === value ? 'text-blue-100' : 'text-gray-500'
            }`}>
              {description}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
